// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../client';
import { processKeys } from '../query-keys';
import {
  updateProcessMapPositionsContract,
  resetProcessMapPositionsContract,
  type UpdateProcessMapPositionsRequest,
  type UpdateProcessMapPositionsResponse,
  type ResetProcessMapPositionsResponse,
  type GetProcessMapResponse
} from '@bliks-io/contracts';

// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated

type ProcessMapData = GetProcessMapResponse['data'];

function withSavedLayout(
  map: ProcessMapData,
  { positions, laneDimensions = [] }: UpdateProcessMapPositionsRequest
): ProcessMapData {
  const savedPositions = new Map(positions.map(({ processId, x, y }) => [processId, { x, y }]));
  const savedLaneKeys = new Set(laneDimensions.map(({ laneKey }) => laneKey));
  return {
    ...map,
    processes: map.processes.map((process) => {
      const mapPosition = savedPositions.get(process._id);
      return mapPosition ? { ...process, mapPosition } : process;
    }),
    laneDimensions: [
      ...(map.laneDimensions ?? []).filter(({ laneKey }) => !savedLaneKeys.has(laneKey)),
      ...laneDimensions
    ]
  };
}

function withoutSavedLayout(map: ProcessMapData): ProcessMapData {
  return {
    ...map,
    processes: map.processes.map((process) => ({ ...process, mapPosition: undefined })),
    laneDimensions: []
  };
}

/**
 * Bulk upsert process map node positions (debounced save after drag)
 */
export function useUpdateProcessMapPositions() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      data: UpdateProcessMapPositionsRequest
    ): Promise<UpdateProcessMapPositionsResponse> => {
      const { data: response } = await apiClient.put<UpdateProcessMapPositionsResponse>(
        updateProcessMapPositionsContract.path,
        data
      );
      return response;
    },
    // The cache shows the saved layout before the refetch, so a failed refetch cannot revert it.
    onSuccess: (_response, request) => {
      queryClient.setQueryData<ProcessMapData>(
        processKeys.map(),
        (map) => map && withSavedLayout(map, request)
      );
      void queryClient.invalidateQueries({ queryKey: processKeys.map() });
    }
  });
}

/**
 * Reset all saved positions → back to auto-layout
 */
export function useResetProcessMapPositions() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (): Promise<ResetProcessMapPositionsResponse> => {
      const { data } = await apiClient.delete<ResetProcessMapPositionsResponse>(
        resetProcessMapPositionsContract.path
      );
      return data;
    },
    onSuccess: () => {
      queryClient.setQueryData<ProcessMapData>(
        processKeys.map(),
        (map) => map && withoutSavedLayout(map)
      );
      void queryClient.invalidateQueries({ queryKey: processKeys.map() });
    }
  });
}
